export const getLoaderVisible = state => state.loader
